import React from 'react'
import { createRoot } from 'react-dom/client'
import ReactRailsUJS from 'react_ujs'

export const componentLoadPathContextFactory = (components) => {
  return (fileToImport) => components[fileToImport.replace(/^\.\//, '')]
}

export const mount = (components) => {
  const componentLoadPathContext = componentLoadPathContextFactory(components)
  ReactRailsUJS.useContext(componentLoadPathContext)
  ReactRailsUJS.mountComponents = () => {
    document.querySelectorAll('[data-react-class]').forEach((node) => {
      const klass = ReactRailsUJS.getConstructor(node.getAttribute('data-react-class'))
      const props = JSON.parse(node.getAttribute('data-react-props'))
      const root = createRoot(node)
      root.render(React.createElement(klass, props))
    })
  }
}
